export enum IntegrationSyncStatus {
  Failed = 'failed',
  Pending = 'pending',
  Syncing = 'syncing',
  Success = 'success',
  SuccessWithWarnings = 'success_with_warnings',
  Timeout = 'timeout',
}
